export default __webpack_public_path__ + "d89560e365827e2fb829b9cf2cc404a9.svg";